// Eventbus used to open sidebar.
// https://alligator.io/vuejs/global-event-bus/
// https://www.digitalocean.com/community/tutorials/vuejs-global-event-bus
//
// To use:
// import EventBus from '@/plugins/eventbus'
//
// Send event:
// EventBus.$emit('i-got-clicked', this.clickCount);
//
// Receive event:
//
// EventBus.$on('i-got-clicked', clickCount => {
//   console.log(`Clicks: ${clickCount}`)
// })

import Vue from 'vue'
const EventBus = new Vue()

export default EventBus



// WEBPACK FOOTER //
// ./src/plugins/eventbus.js